// reviewMassWrite(리뷰 대량 등록) 페이지 온보딩 투어
// 엑셀로 리뷰를 한 번에 등록하는 3단계 위저드 — 진행단계 → 양식·매핑 → 파일 업로드 → 등록내역.
import { buildSteps } from '../tourStep';

export function buildReviewMassWriteSteps(ctx, tour) {
  return buildSteps([
    {
      id: 'welcome',
      emoji: '📦',
      title: '리뷰 대량 등록에 오신 걸 환영해요!',
      text: '엑셀(.xlsx)·CSV 파일로 리뷰를 한 번에 최대 <b>500건</b>까지 등록할 수 있어요. 흐름을 함께 볼게요 :)',
      attachTo: null,
    },
    {
      id: 'stepper',
      emoji: '🪜',
      title: '진행 단계',
      text: '<b>① 파일 업로드 → ② 데이터 확인·편집 → ③ 최종 등록</b>, 3단계로 진행돼요.',
      attachTo: { element: '.rmw-stepper', on: 'bottom' },
    },
    {
      id: 'mapping',
      emoji: '🧩',
      title: '양식 · 컬럼 매핑',
      text: '플랫폼/양식을 고르고, 엑셀 컬럼을 온리플 항목에 맞게 <b>매핑</b>할 수 있어요. 자주 쓰는 양식은 저장해두세요.',
      attachTo: { element: '.rmw-upload-guide__left', on: 'right' },
      beforeShow: '.rmw-upload-guide__left',
    },
    {
      id: 'upload',
      emoji: '📤',
      title: '파일 업로드',
      text: '엑셀·CSV 파일을 <b>드래그하거나 클릭</b>해 업로드하세요. (.xlsx / .csv · 최대 500건)',
      attachTo: { element: '.rmw-dropzone', on: 'left' },
      beforeShow: '.rmw-dropzone',
    },
    {
      id: 'history',
      emoji: '📂',
      title: '등록 내역 보기',
      text: '이전에 대량 등록한 리뷰는 <b>대량 등록 리뷰 보기</b>에서 확인할 수 있어요.',
      attachTo: { element: '.rmw-header__actions', on: 'bottom' },
      beforeShow: '.rmw-header__actions',
    },
    {
      id: 'done',
      emoji: '🎉',
      title: '준비 끝!',
      text: '이제 파일을 올려 한 번에 등록해보세요. 다시 보고 싶으면 제목 옆 <b>?</b> 버튼을 누르면 돼요.',
      attachTo: null,
    },
  ], tour);
}

export default buildReviewMassWriteSteps;
